import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Landing from "@/pages/Landing";
import ClienteHub from "@/pages/ClienteHub";
import Login from "@/pages/Login";
import CadastroMontador from "@/pages/CadastroMontador";
import EscolhaCadastro from "@/pages/EscolhaCadastro";
import ClienteParticular from "@/pages/ClienteParticular";
import ConexaoParticular from "@/pages/ConexaoParticular";
import OfertaMontagem from "@/pages/OfertaMontagem";
import PortalPedido from "@/pages/PortalPedido";
import ParticularOfertas from "@/pages/admin/ParticularOfertas";
import AtividadeRede from "@/pages/admin/AtividadeRede";
import Manuais from "@/pages/admin/Manuais";
import CadastroMontadora from "@/pages/CadastroMontadora";
import ContratoMontador from "@/pages/ContratoMontador";
import ContratoMontadora from "@/pages/ContratoMontadora";
import CadastroEmpresa from "@/pages/CadastroEmpresa";
import QRCodeCliente from "@/pages/QRCodeCliente";
import ApresentacaoParticular from "@/pages/ApresentacaoParticular";
import AdminShowroom from "@/pages/admin/Showroom";
import ApresentacaoEmpresa, { DemoEmpresaEntrar } from "@/pages/ApresentacaoEmpresa";
import DemoCliente from "@/pages/DemoCliente";
import DemoCheckout from "@/pages/DemoCheckout";
import ClienteConfirmar from "@/pages/ClienteConfirmar";
import ClienteAcompanhar from "@/pages/ClienteAcompanhar";
import ClienteAvaliacao from "@/pages/ClienteAvaliacao";
import ClientePosVenda from "@/pages/ClientePosVenda";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminEmpresas from "@/pages/admin/Empresas";
import MinhaEmpresa from "@/pages/admin/MinhaEmpresa";
import MinhaEquipe from "@/pages/admin/MinhaEquipe";
import LimpezaTeste from "@/pages/admin/LimpezaTeste";
import RegularizarFatura from "@/pages/RegularizarFatura";
import ConexoesParticulares from "@/pages/admin/ConexoesParticulares";
import FaturamentoSaas from "@/pages/admin/FaturamentoSaas";
import AdminMontadoras from "@/pages/admin/Montadoras";
import AdminMontadores from "@/pages/admin/Montadores";
import AdminServicos from "@/pages/admin/Servicos";
import AdminServicoDetalhe from "@/pages/admin/ServicoDetalhe";
import CatalogoTempos from "@/pages/admin/CatalogoTempos";
import AlertasOperacionais from "@/pages/admin/AlertasOperacionais";
import MontadorFicha from "@/pages/admin/MontadorFicha";
import AdminAssistencias from "@/pages/admin/Assistencias";
import AvaliacoesPosMontagem from "@/pages/admin/AvaliacoesPosMontagem";
import AdminGarantias from "@/pages/admin/Garantias";
import AdminCondicoes from "@/pages/admin/Condicoes";
import ReferenciasValores from "@/pages/admin/ReferenciasValores";
import CondicoesRede from "@/components/CondicoesRede";
import AdminFinanceiro from "@/pages/admin/Financeiro";
import AdminAuditoria from "@/pages/admin/Auditoria";
import AdminAssinaturas from "@/pages/admin/Assinaturas";
import AdminVolumetria from "@/pages/admin/Volumetria";
import AdminRelatorios from "@/pages/admin/Relatorios";
import AdminPesquisarMontadoras from "@/pages/admin/PesquisarMontadoras";
import AdminAuditoriaJuridica from "@/pages/admin/AuditoriaJuridica";
import AdminAgregadoMontadores from "@/pages/admin/AgregadoMontadores";
import AdminConfiguracoes from "@/pages/admin/Configuracoes";
import AdminCasosSucesso from "@/pages/admin/CasosSucesso";
import AdminValoresServicos from "@/pages/admin/ValoresServicos";
import AdminCalendarioFechamento from "@/pages/admin/CalendarioFechamento";
import AdminConfigFiscal from "@/pages/admin/ConfigFiscal";
import AdminNotasFiscaisEmpresa from "@/pages/admin/NotasFiscaisEmpresa";
import AdminComunicados from "@/pages/admin/Comunicados";
import AdminAditivos from "@/pages/admin/Aditivos";
import ContratosMontador from "@/pages/admin/ContratosMontador";
import ExtratoMontadora from "@/pages/admin/ExtratoMontadora";
import AdminCampanhas from "@/pages/admin/Campanhas";
import AdminFinanceiroMontadora from "@/pages/admin/FinanceiroMontadora";
import AdminPlanosAcao from "@/pages/admin/PlanosAcao";
import MontadorAditivos from "@/pages/montador/Aditivos";
import MontadorContratos from "@/pages/montador/Contratos";
import MontadorComunicados from "@/pages/montador/Comunicados";
import MontadorPerfilFiscal from "@/pages/montador/PerfilFiscal";
import MontadorConfigOperacional from "@/pages/montador/ConfigOperacional";
import AdminBackups from "@/pages/admin/Backups";
import AdminAlertasCapacidade from "@/pages/admin/AlertasCapacidade";
import AdminQRCode from "@/pages/admin/QRCode";
import AdminImportar from "@/pages/admin/ImportarPlanilha";
import AdminPulmao from "@/pages/admin/Pulmao";
import AdminChat from "@/pages/admin/Chat";
import Atendimento from "@/pages/Atendimento";
import MontadorPainel from "@/pages/montador/Painel";
import MontadorLayout from "@/pages/montador/MontadorLayout";
import MontadorServico from "@/pages/montador/ServicoDetalhe";
import MontadorAgenda from "@/pages/montador/Agenda";
import MontadorNotasFiscais from "@/pages/montador/NotasFiscais";
import MontadorFinanceiro from "@/pages/montador/Financeiro";
import AdminInsights from "@/pages/admin/Insights";
import AdminAvaliacoes from "@/pages/admin/Avaliacoes";
import MinhasFaturas from "@/pages/MinhasFaturas";
import AvaliacoesPlataforma from "@/pages/admin/AvaliacoesPlataforma";
import MensagensWhatsApp from "@/pages/admin/MensagensWhatsApp";
import Parcerias from "@/pages/admin/Parcerias";
import AlertasDesempenho from "@/pages/admin/AlertasDesempenho";
import RegioesAtendimento from "@/pages/admin/RegioesAtendimento";
import OcorrenciasMontadora from "@/pages/admin/OcorrenciasMontadora";
import CadastrosPendentes from "@/pages/admin/CadastrosPendentes";
import LeadsDemonstracao from "@/pages/admin/LeadsDemonstracao";
import ValoresEmpresas from "@/pages/ValoresEmpresas";
import AtivacaoEmpresa from "@/pages/AtivacaoEmpresa";
import ExtratoTaxa from "@/pages/montadora-pages/ExtratoTaxa";
import SplashIntro from "@/components/SplashIntro";
import AceitesGate from "@/components/AceitesGate";
import CentralPendenciasGate from "@/components/CentralPendenciasGate";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  const location = window.location.pathname;
  if (loading) return <div className="min-h-screen flex items-center justify-center">Carregando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/login" replace />;
  const aprovado = !user.aprovacao_status || user.aprovacao_status === "aprovada";
  if (user.role === "montador" && user.primeiro_acesso && aprovado && location !== "/montador/contrato") {
    return <Navigate to="/montador/contrato" replace />;
  }
  if (user.role === "montadora" && user.primeiro_acesso && aprovado && location !== "/montadora/contrato") {
    return <Navigate to="/montadora/contrato" replace />;
  }
  if (!aprovado && (location === "/montador/contrato" || location === "/montadora/contrato")) {
    return <Navigate to={user.role === "montador" ? "/montador" : "/admin"} replace />;
  }
  return children;
}

function RoleRouter() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  if (user.role === "empresa") return <Navigate to="/empresa" replace />;
  if (user.role === "montadora") {
    if (user.primeiro_acesso) return <Navigate to="/montadora/contrato" replace />;
    return <Navigate to="/montadora" replace />;
  }
  if (user.role === "montador") {
    if (user.primeiro_acesso) return <Navigate to="/montador/contrato" replace />;
    return <Navigate to="/montador" replace />;
  }
  return <Navigate to="/login" replace />;
}

function PainelGuard({ prefix, children }) {
  const { user } = useAuth();
  const location = useLocation();
  const alvo = user?.role === "admin" ? "admin" : user?.role;
  if (user && ["admin", "empresa", "montadora"].includes(user.role) && alvo !== prefix) {
    const resto = location.pathname.replace(/^\/(admin|empresa|montadora)/, "");
    return <Navigate to={`/${alvo}${resto}${location.search}`} replace />;
  }
  return children;
}

const painelChildren = () => (
  <>
            <Route index element={<AdminDashboard />} />
            <Route path="empresas" element={<AdminEmpresas />} />
            <Route path="minha-empresa" element={<MinhaEmpresa />} />
            <Route path="equipe" element={<MinhaEquipe />} />
            <Route path="conexoes-particulares" element={<ConexoesParticulares />} />
            <Route path="faturamento-saas" element={<FaturamentoSaas />} />
            <Route path="minhas-faturas" element={<MinhasFaturas />} />
            <Route path="avaliacoes-plataforma" element={<AvaliacoesPlataforma />} />
            <Route path="mensagens-whatsapp" element={<MensagensWhatsApp />} />
            <Route path="parcerias" element={<Parcerias />} />
            <Route path="alertas-desempenho" element={<AlertasDesempenho />} />
            <Route path="regioes-atendimento" element={<RegioesAtendimento />} />
            <Route path="ocorrencias-montadora" element={<OcorrenciasMontadora />} />
            <Route path="extrato-taxa" element={<ExtratoTaxa />} />
            <Route path="cadastros-pendentes" element={<CadastrosPendentes />} />
            <Route path="limpeza-teste" element={<LimpezaTeste />} />
            <Route path="leads" element={<LeadsDemonstracao />} />
            <Route path="valores-empresas" element={<ValoresEmpresas />} />
            <Route path="montadoras" element={<AdminMontadoras />} />
            <Route path="montadores" element={<AdminMontadores />} />
            <Route path="montadores/:montadorId" element={<MontadorFicha />} />
            <Route path="cliente-particular" element={<ParticularOfertas />} />
            <Route path="atividade-rede" element={<AtividadeRede />} />
            <Route path="manuais" element={<Manuais />} />
            <Route path="alertas-operacionais" element={<AlertasOperacionais />} />
            <Route path="catalogo-tempos" element={<CatalogoTempos />} />
            <Route path="servicos" element={<AdminServicos />} />
            <Route path="servicos/:servicoId" element={<AdminServicoDetalhe />} />
            <Route path="importar" element={<AdminImportar />} />
            <Route path="qrcodes" element={<AdminQRCode />} />
            <Route path="assistencias" element={<AdminAssistencias />} />
            <Route path="avaliacoes-pos-montagem" element={<AvaliacoesPosMontagem />} />
            <Route path="garantias" element={<AdminGarantias />} />
            <Route path="condicoes" element={<AdminCondicoes />} />
            <Route path="condicoes-empresas" element={<CondicoesRede endpoint="/montadora/condicoes" />} />
            <Route path="referencias-valores" element={<ReferenciasValores />} />
            <Route path="pulmao" element={<AdminPulmao />} />
            <Route path="chat" element={<AdminChat />} />
            <Route path="insights" element={<AdminInsights />} />
            <Route path="avaliacoes" element={<AdminAvaliacoes />} />
            <Route path="financeiro" element={<AdminFinanceiro />} />
            <Route path="relatorios" element={<AdminRelatorios />} />
            <Route path="showroom" element={<AdminShowroom />} />
            <Route path="volumetria" element={<AdminVolumetria />} />
            <Route path="pesquisar-montadoras" element={<AdminPesquisarMontadoras />} />
            <Route path="agregado-montadores" element={<AdminAgregadoMontadores />} />
            <Route path="casos-sucesso" element={<AdminCasosSucesso />} />
            <Route path="valores-servicos" element={<AdminValoresServicos />} />
            <Route path="calendario-fechamento" element={<AdminCalendarioFechamento />} />
            <Route path="config-fiscal" element={<AdminConfigFiscal />} />
            <Route path="notas-fiscais" element={<AdminNotasFiscaisEmpresa />} />
            <Route path="comunicados" element={<AdminComunicados />} />
            <Route path="aditivos" element={<AdminAditivos />} />
            <Route path="contratos-montador" element={<ContratosMontador />} />
            <Route path="campanhas" element={<AdminCampanhas />} />
            <Route path="financeiro-montadora" element={<AdminFinanceiroMontadora />} />
            <Route path="extrato-montadora" element={<ExtratoMontadora />} />
            <Route path="planos-acao" element={<AdminPlanosAcao />} />
            <Route path="backups" element={<AdminBackups />} />
            <Route path="configuracoes" element={<AdminConfiguracoes />} />
            <Route path="assinaturas" element={<AdminAssinaturas />} />
            <Route path="auditoria-juridica" element={<AdminAuditoriaJuridica />} />
            <Route path="auditoria" element={<AdminAuditoria />} />
  </>
);

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <SplashIntro />
        <AceitesGate />
        <CentralPendenciasGate />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/regularizar/:faturaId" element={<RegularizarFatura />} />
          <Route path="/cadastro" element={<EscolhaCadastro />} />
          <Route path="/montadores" element={<ClienteParticular />} />
          <Route path="/particular/conexao/:conexaoId" element={<ConexaoParticular />} />
          <Route path="/oferta/:token" element={<OfertaMontagem />} />
          <Route path="/portal/:token" element={<PortalPedido />} />
          <Route path="/apresentacao-particular" element={<ApresentacaoParticular />} />
          <Route path="/apresentacao-empresa" element={<ApresentacaoEmpresa />} />
          <Route path="/demo/cliente/:sessao" element={<DemoCliente />} />
          <Route path="/demo/checkout/:token" element={<DemoCheckout />} />
          <Route path="/demo/empresa/:sessao" element={<DemoEmpresaEntrar />} />
          <Route path="/cadastro-montador" element={<CadastroMontador />} />
          <Route path="/cadastro-montadora" element={<CadastroMontadora />} />
          <Route path="/cadastro-empresa" element={<CadastroEmpresa />} />
          <Route path="/ativacao/:token" element={<AtivacaoEmpresa />} />
          <Route path="/atendimento/:token" element={<Atendimento />} />
          <Route path="/qrcode" element={<QRCodeCliente />} />
          <Route path="/cliente" element={<ClienteHub />} />
          <Route path="/cliente/confirmar/:planilhaId" element={<ClienteConfirmar />} />
          <Route path="/cliente/servico/:servicoId" element={<ClienteAcompanhar />} />
          <Route path="/cliente/avaliacao/:token" element={<ClienteAvaliacao />} />
          <Route path="/cliente/posvenda/:servicoId" element={<ClientePosVenda />} />
          <Route path="/app" element={<RoleRouter />} />

          {/* Admin / Empresa / Montadora compartilham layout — cada perfil no seu prefixo */}
          <Route path="/admin" element={<Protected roles={["admin", "empresa", "montadora"]}><PainelGuard prefix="admin"><AdminLayout /></PainelGuard></Protected>}>
            {painelChildren()}
          </Route>
          <Route path="/empresa" element={<Protected roles={["admin", "empresa", "montadora"]}><PainelGuard prefix="empresa"><AdminLayout /></PainelGuard></Protected>}>
            {painelChildren()}
          </Route>
          <Route path="/montadora" element={<Protected roles={["admin", "empresa", "montadora"]}><PainelGuard prefix="montadora"><AdminLayout /></PainelGuard></Protected>}>
            {painelChildren()}
          </Route>
          {/* Montador */}
          <Route path="/montador/contrato" element={<Protected roles={["montador"]}><ContratoMontador /></Protected>} />
          <Route path="/montadora/contrato" element={<Protected roles={["montadora"]}><ContratoMontadora /></Protected>} />
          <Route path="/montador" element={<Protected roles={["montador"]}><MontadorLayout /></Protected>}>
            <Route index element={<MontadorPainel />} />
            <Route path="agenda" element={<MontadorAgenda />} />
            <Route path="notas-fiscais" element={<MontadorNotasFiscais />} />
            <Route path="financeiro" element={<MontadorFinanceiro />} />
            <Route path="faturas" element={<MinhasFaturas />} />
            <Route path="valores-empresas" element={<ValoresEmpresas />} />
            <Route path="aditivos" element={<MontadorAditivos />} />
            <Route path="contratos" element={<MontadorContratos />} />
            <Route path="comunicados" element={<MontadorComunicados />} />
            <Route path="perfil-fiscal" element={<MontadorPerfilFiscal />} />
            <Route path="configuracoes" element={<MontadorConfigOperacional />} />
            <Route path="condicoes" element={<CondicoesRede endpoint="/montador/condicoes" />} />
            <Route path="servico/:servicoId" element={<MontadorServico />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
